import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/info',
    name: 'info',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/info.vue')
  },
  {
    path: '/comparison',
    name: 'comparison',
    component: () => import(/* webpackChunkName: "about" */ '../views/comparison.vue')
  },
  {
    path: '/contrast',
    name: 'contrast',
    component: () => import(/* webpackChunkName: "about" */ '../views/contrast.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
